var chunkMapping = {
	"71": [
		89071
	],
	"338": [
		38338
	],
	"386": [
		53386
	],
	"504": [
		54504
	],
	"680": [
		58680
	],
	"691": [
		97691
	],
	"860": [
		96860
	],
	"994": [
		19994
	]
};
var idToExternalAndNameMapping = {
	"19994": [
		"default",
		"./routing/RouterLink",
		22081
	],
	"38338": [
		"default",
		"./admin/NavItem",
		22081
	],
	"53386": [
		"default",
		"./admin/AdminLayout",
		22081
	],
	"54504": [
		"default",
		"./shared/layout/FullHeightContainer",
		22081
	],
	"58680": [
		"default",
		"./form/FroalaToolbar",
		22081
	],
	"89071": [
		"default",
		"./form/FroalaEditor",
		22081
	],
	"96860": [
		"default",
		"./form/Editor",
		22081
	],
	"97691": [
		"default",
		"./layout/StickyPageToolbar",
		22081
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}